export default __webpack_public_path__ + "static/media/cv.f4fd7729.pdf";